import React, { useEffect, useState } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { armoryService } from '../../services/central-api/armory';


interface Props {
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
    zIndex: number;
    actingBodyId: number;
    required: boolean;
    labelFontSize?: number;
    disabled?: boolean;
}

function ArmourerDropdown({ value, setValue, zIndex, actingBodyId, required, labelFontSize = 16, disabled = false }: Props) {
    const [selectableUsers, setSelectableUsers] = useState<{ label: string; value: number; }[]>([]);

    async function getUsers(actingBodyId?: number) {
        try {
            const users = await armoryService.getArmourers({ actingBodyId });
            setSelectableUsers([
                ...users.map((user) => {
                    return {
                        value: user.id,
                        label: user.name
                    };
                })
            ]);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (actingBodyId !== 0) {
            getUsers(actingBodyId);
        }
    }, [actingBodyId]);

    return (
        <FilterDropdown
            label={translate('armourerInCharge')}
            items={selectableUsers}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            required={required}
            labelFontSize={labelFontSize}
            disabled={disabled}
        />
    );
}

export default ArmourerDropdown;
